import { Volume2 } from "lucide-react";
import { ASPECT_CLASS } from "./Placeholder";

export const RealMedia = ({ project, onOpen }) => {
  const ar = project.aspect_ratio || "16:9";
  const isMP4 = project.video_type === "mp4";
  const isImage = project.video_type === "image" || !project.video_url;
  const vimeoId = !isMP4 && !isImage ? project.video_url.split("/").pop().split("?")[0] : null;
  const clickable = !isImage;

  return (
    <div
      className={`relative w-full ${ASPECT_CLASS[ar] || "aspect-video"} rounded-2xl md:rounded-3xl overflow-hidden bg-[#1C1C1C] group/media ${clickable ? "cursor-pointer" : ""}`}
      onClick={clickable ? onOpen : undefined}
      data-testid={`cs-media-${project.id}`}
    >
      {isImage ? (
        <img src={project.thumbnail} alt={project.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover/media:scale-[1.03]" />
      ) : isMP4 ? (
        <video src={project.video_url} poster={project.thumbnail} autoPlay muted loop playsInline preload="metadata" className="w-full h-full object-cover" />
      ) : (
        <iframe
          src={`https://player.vimeo.com/video/${vimeoId}?background=1&autoplay=1&loop=1&muted=1`}
          className="absolute inset-0 w-full h-full"
          allow="autoplay; fullscreen"
          title={project.title}
        />
      )}
      {clickable && (
        <div className="absolute bottom-4 right-4 flex items-center gap-2 bg-black/60 backdrop-blur-sm text-white text-xs font-semibold px-4 py-2 rounded-full opacity-0 group-hover/media:opacity-100 transition-opacity duration-300 pointer-events-none">
          <Volume2 size={13} /> Watch with sound
        </div>
      )}
    </div>
  );
};
